export default __webpack_public_path__ + "images/98c1977bfb73013dead4ee553f1dc7ae-discover.svg";